module.exports = __webpack_public_path__ + "static/media/icon_edit.9f1645af.png";